import { useEffect } from "react";
import { motion } from "framer-motion"
import { Link, useNavigate } from "react-router-dom";
export const BtnMenu = ({ open, setOpen }) => {
    const navigate = useNavigate();

    const handleKeyDown = (e) => {
        console.log(e.key);
        if (e.altKey && e.key === 'm') {
            navigate('/admin');
        }
    }

    useEffect(() => {
        window.addEventListener('keyup', handleKeyDown);
        return () => {
            window.removeEventListener('keyup', handleKeyDown);
        }
    }, [])

    return (
        <motion.div
            initial={false}
            animate={{ zIndex: open ? 5 : 2 }}
            onClick={() => setOpen(!open)}
            className="btn-menu d-flex flex-column">
            <motion.i
                initial={{ rotate: 45 }}
                animate={{ rotate: open ? 0 : 45 }}
                className="bi bi-slash-lg my-0" />
            <motion.i
                initial={{ rotate: 45, y: -15 }}
                animate={{ rotate: open ? 90 : 45 }}
                className="bi bi-slash-lg my-0" />
            <motion.i
                initial={{ rotate: 45, y: -30 }}
                animate={{ opacity: open ? 0 : 1, rotate: open ? 0 : 45 }}
                className="bi bi-slash-lg my-0" />
        </motion.div>
    );
}

export const Menu = ({ open, setOpen }) => {

    return (
        <motion.div
            initial={{ y: '-100%' }}
            animate={{ y: 0 }}
            exit={{ y: '-100%' }}
            className="h-100 w-100 shadow-sm d-flex justify-content-center align-items-center">
            <motion.ul className="nav flex-column justify-content-center align-center text-center _menu">
                <li className="nav-item ">
                    <Link className="nav-link" to="/" onClick={() => setOpen(!open)}>
                        <strong>Home</strong>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/portafolio" onClick={() => setOpen(!open)}>
                        <strong>Portafolio</strong>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/lab" onClick={() => setOpen(!open)}>
                        <strong>Code Lab</strong>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link" to="/contact" onClick={() => setOpen(!open)}>
                        <strong>
                            Contacto
                        </strong>

                    </Link>
                </li>
            </motion.ul>

        </motion.div>
    )

}

